/**
 * Java API SSE 连接服务
 * 基于通用的 SSE 工具类，提供 Java API 专用的 SSE 连接功能
 */
import { createSSEConnect as createSSEConnectUtil, getSSEConnectUrl as getSSEConnectUrlUtil, SSEManager, sseManager } from '@/utils/sse'

/**
 * 获取 SSE 连接 URL（Java API）
 * 用于创建 Server-Sent Events 连接，实现服务端推送
 * 使用 javaToken 作为认证 token
 * 
 * @param {Object} body - 请求参数
 * @param {Object} body.params - 查询参数（可选）
 * @returns {string} SSE 连接 URL
 */
export function getSSEConnectUrl(body = {}) {
  const { params = {} } = body || {}
  return getSSEConnectUrlUtil({
    configType: 'java',
    endpoint: '/sse/connect',
    params
  })
}

/**
 * 创建 SSE 连接（Java API）
 * 用于服务端推送数据到客户端
 * 使用 javaToken 作为认证 token
 * 
 * @param {Object} body - 请求参数
 * @param {Object} body.params - 查询参数（可选）
 * @param {Function} body.onMessage - 消息处理回调函数 (event) => {}
 * @param {Function} body.onError - 错误处理回调函数 (error) => {}
 * @param {Function} body.onOpen - 连接打开回调函数 () => {}
 * @param {Function} body.onClose - 连接关闭回调函数 () => {}
 * @returns {EventSource} EventSource 实例
 * 
 * @example
 * // 创建 SSE 连接
 * const eventSource = createSSEConnect({
 *   params: { userId: '123' },
 *   onMessage: (event) => {
 *     console.log('收到消息:', event.data)
 *   },
 *   onError: (error) => {
 *     console.error('连接错误:', error)
 *   },
 *   onOpen: () => {
 *     console.log('连接已打开')
 *   }
 * })
 * 
 * // 关闭连接
 * eventSource.close()
 */
export function createSSEConnect(body = {}) {
  const { params = {}, onMessage, onError, onOpen, onClose, onActivity } = body || {}
  
  return createSSEConnectUtil({
    configType: 'java',
    endpoint: '/sse/connect',
    params,
    onMessage,
    onError,
    onOpen,
    onClose,
    onActivity
  })
}

// 导出 SSE 管理器类（供需要管理多个连接时使用）
export { SSEManager, sseManager }
